import React from "react";
import { Container } from "react-bootstrap";
import ecom from "../../../../Asset/hero-ecommerce.svg";

const Second = () => {
  return (
    <>
      <section
        className="side-image-box-section"
        style={{ background: "var(--white-color)" }}
      >
        <Container>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 order-2">
              <div className="info-content">
                <div className="title-paragraph">
                  A good internet presence is one of a company's most critical
                  components.
                </div>
                <p>
                  A website is the first thing a potential customer will see
                  while researching your company. It’s crucial to check that
                  your website is useful, user-friendly, and well-designed.
                </p>
                <p>
                  A website that enables online product or service purchases is
                  known as an eCommerce website. The user experience must be
                  taken into consideration while designing an eCommerce website.
                  The website should be simple to use, and the checkout
                  procedure should be quick and easy.
                </p>
                <p>
                  A good e-Commerce website will also offer a variety of payment
                  options to make it easy for customers to purchase your
                  products. The most popular payment options are credit cards,
                  PayPal, and Apple Pay. If you are running a business, it is
                  essential to have a website. A website will help you reach a
                  wider audience and generate more sales. Investing in a good
                  eCommerce website is one of the best decisions you can make
                  for your business.
                </p>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 order-1">
              <div className="info-img">
                <img alt="infoImage" src={ecom} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Second;
